import { AIRuleSets } from './aiRuleSets';
import { AIRules } from './aiRules';
import { GameEvent } from './definitions';
import { Rules } from './rules';
import { User } from './user';
const aiRulesInstantiated = new AIRules();
export class UserComputer extends User {
    constructor(name, id, avatar, level, delay = 1000, debug = false) {
        super(name, id, avatar, level);
        this.delay = delay;
        this.level = level;
        this.allRulesAi = aiRulesInstantiated;
        this.ruleset = AIRuleSets[level] ?? AIRuleSets['Easy'];
        this.debug = debug;
    }
    onMessage(eventName, ...args) {
        if (this.debug) {
            console.log('UserComputer.onMessage', eventName, args);
        }
        if (eventName === GameEvent.PlayerChanged) {
            this.OnPlayerChanged();
            return;
        }
        this.OnGameChanged();
    }
    //onInvalidAction() { this.TakeAction(); }
    OnGameChanged() {
        if (!this.delay) {
            return;
        }
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.TakeAction();
        }, this.delay);
    }
    OnPlayerChanged() {
        // if (!this.game?.gameState) return;
        // let gameState: GameState = this.game.gameState;
        // let gamePlayer = gameState.players.find(p => p.id === this.id);
        // this.tablePosition = gamePlayer ? gamePlayer.tablePosition : -1;
    }
    TakeAction() {
        if (!this.game?.gameState) {
            return;
        }
        const gameState = this.game.gameState;
        const tablePosition = this.tablePosition;
        const action = this.getAction(gameState, tablePosition);
        if (action) {
            if (this.debug) {
                console.log(`Computer: ${action.note}`);
            }
            this.game?.action(action.command, action.commandData, tablePosition);
        }
    }
    getAction(gameState, tablePosition) {
        return getAiAction(gameState, tablePosition, this.level);
    }
}
export function getAiAction(gameState, tablePosition, level) {
    //get brain with set of rules
    const allRulesAi = aiRulesInstantiated;
    const ruleset = AIRuleSets[level];
    //get current state of game
    const roundStage = gameState.roundStage;
    const rulesetForStage = ruleset[roundStage];
    //get all rules for this round stage
    for (const ruleName of rulesetForStage) {
        const ruleAi = allRulesAi[ruleName];
        if (typeof ruleAi !== 'function') {
            continue;
        }
        const action = ruleAi(gameState, tablePosition);
        if (!action) {
            continue;
        }
        if (!Rules.can(action.command, action.commandData, tablePosition, gameState)) {
            continue;
        } //incase the ruleAI returns an action that is not allowed //could be moved to the rulesAI
        return action;
    }
    return null;
}
//# sourceMappingURL=data:application/json;base64,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